import { Input } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldTextArea = ({ value, onChange, ...props }) => {
  return (<Input.TextArea rows={4} value={value} onChange={onChange} {...props} />);
};

DynamicFieldTextArea.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldTextArea);
